<template>
  <div class="main-container" id="why-prime">
    <span class="choose-abanprime">Why Choose {{title}}?</span>
    <div class="why-choose-us">
      <div class="empty">
        <div class="smart-mobile-banking"></div>
        <div class="frame">
          <span class="top-notch-security">Top-Notch Security</span
          ><span class="secured-encryption"
            >Your transactions are secured with advanced encryption, ensuring
            full protection from start to finish.</span
          >
        </div>
      </div>
    </div>
    <div class="empty-1">
      <div class="smart-mobile-trading-app"></div>
      <div class="frame-2">
        <span class="online-dirham-market">Online {{ mainAssetName }} Market</span
        ><span class="access-competitive-rates"
          >Access competitive rates anytime, anywhere, and trade with ease from
          your account.</span
        >
      </div>
    </div>
    <div v-if="!(['arvand', 'ariyosh'].includes(product))" class="section-2">
      <div class="smart-delivery-robot"></div>
      <div class="frame-3">
        <span class="cash-delivery">Cash Delivery</span
        ><span class="convenient-delivery"
          >Enjoy convenient cash delivery services available from 9 AM to 10 PM,
          right at your doorstep.</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import settings from "../../settings"

export default {
  name: 'Why Prime',
  data() {
    return {
      title: settings.PRODUCT_TITLE,
      product: settings.PRODUCT
    }
  },
  computed: {
    mainAssetName() {
      return (['arvand', 'ariyosh'].includes(this.product)) ? 'Tether' : 'Dirham'
    }
  }
}
</script>


<style scoped>
.main-container {
  overflow: hidden;
}

.main-container,
.main-container * {
  box-sizing: border-box;
}

.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  gap: calc(48 * var(--rpx));
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: calc(36 * var(--rpx)) calc(32 * var(--rpx)) calc(36 * var(--rpx))
    calc(32 * var(--rpx));
  background: linear-gradient(180deg, #d5e6ff, #dde6f2);
}
.choose-abanprime {
  align-self: stretch;
  flex-shrink: 0;
  flex-basis: auto;
  position: relative;
  height: calc(32 * var(--rpx));
  color: #0e2546;
  font-family: dana, var(--default-font-family);
  font-size: calc(24 * var(--rpx));
  font-weight: 700;
  line-height: calc(32 * var(--rpx));
  text-align: center;
  white-space: nowrap;
}
.why-choose-us {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  flex-wrap: nowrap;
  flex-shrink: 0;
  gap: calc(36 * var(--rpx));
  position: relative;
  z-index: 1;
}
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  flex-wrap: nowrap;
  flex-shrink: 0;
  gap: calc(20 * var(--rpx));
  position: relative;
  z-index: 2;
}
.smart-mobile-banking {
  flex-shrink: 0;
  position: relative;
  width: calc(200 * var(--rpx));
  height: calc(200 * var(--rpx));
  background: url(@/assets/banners/TopNotchSecurity.png)
    no-repeat center;
  background-size: cover;
  z-index: 3;
}
.frame {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  flex-shrink: 0;
  gap: calc(6 * var(--rpx));
  position: relative;
  width: calc(269 * var(--rpx));
  z-index: 4;
}
.top-notch-security {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  flex-basis: auto;
  position: relative;
  width: calc(202 * var(--rpx));
  height: calc(24 * var(--rpx));
  color: #0e2546;
  font-family: dana, var(--default-font-family);
  font-size: calc(18 * var(--rpx));
  font-weight: 500;
  line-height: calc(24 * var(--rpx));
  text-align: center;
  white-space: nowrap;
  z-index: 5;
}
.secured-encryption {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  width: calc(269 * var(--rpx));
  height: calc(60 * var(--rpx));
  color: #0e2546;
  font-family: dana, var(--default-font-family);
  font-size: calc(16 * var(--rpx));
  font-weight: 400;
  line-height: calc(20 * var(--rpx));
  text-align: center;
  z-index: 6;
}
.empty-1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  flex-wrap: nowrap;
  flex-shrink: 0;
  gap: calc(20 * var(--rpx));
  position: relative;
  z-index: 7;
}
.smart-mobile-trading-app {
  flex-shrink: 0;
  position: relative;
  width: calc(200 * var(--rpx));
  height: calc(200 * var(--rpx));
  background: url(@/assets/banners/OnlineDirhamMarket.png)
    no-repeat center;
  background-size: cover;
  z-index: 8;
}
.frame-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  flex-shrink: 0;
  gap: calc(6 * var(--rpx));
  position: relative;
  width: calc(269 * var(--rpx));
  z-index: 9;
}
.online-dirham-market {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  flex-basis: auto;
  position: relative;
  width: calc(202 * var(--rpx));
  height: calc(24 * var(--rpx));
  color: #0e2546;
  font-family: dana, var(--default-font-family);
  font-size: calc(18 * var(--rpx));
  font-weight: 500;
  line-height: calc(24 * var(--rpx));
  text-align: center;
  white-space: nowrap;
  z-index: 10;
}
.access-competitive-rates {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  width: calc(269 * var(--rpx));
  height: calc(60 * var(--rpx));
  color: #0e2546;
  font-family: dana, var(--default-font-family);
  font-size: calc(16 * var(--rpx));
  font-weight: 400;
  line-height: calc(20 * var(--rpx));
  text-align: center;
  z-index: 11;
}
.section-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  flex-wrap: nowrap;
  flex-shrink: 0;
  gap: calc(20 * var(--rpx));
  position: relative;
  z-index: 12;
}

.smart-delivery-robot {
  flex-shrink: 0;
  position: relative;
  width: calc(200 * var(--rpx));
  height: calc(200 * var(--rpx));
  background: url(@/assets/banners/CashDelivery.png) 
    no-repeat center;
  background-size: cover;
  z-index: 13;
}

.frame-3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  flex-shrink: 0;
  gap: calc(6 * var(--rpx));
  position: relative;
  width: calc(269 * var(--rpx));
  z-index: 14;
}
.cash-delivery {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  flex-basis: auto;
  position: relative;
  width: calc(202 * var(--rpx));
  height: calc(24 * var(--rpx));
  color: #0e2546;
  font-family: dana, var(--default-font-family);
  font-size: calc(18 * var(--rpx));
  font-weight: 500;
  line-height: calc(24 * var(--rpx));
  text-align: center;
  white-space: nowrap;
  z-index: 15;
}
.convenient-delivery {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  width: calc(269 * var(--rpx));
  height: calc(60 * var(--rpx));
  color: #0e2546;
  font-family: dana, var(--default-font-family);
  font-size: calc(16 * var(--rpx));
  font-weight: 400;
  line-height: calc(20 * var(--rpx));
  text-align: center;
  z-index: 16;
}
</style>